import { useContext } from "react";
import { Link, useOutletContext } from "react-router-dom";
import {
  FaArrowRight,
  FaExternalLinkAlt,
  FaYoutube,
  FaFacebook,
  FaInstagram,
} from "react-icons/fa";
import { DarkModeContext } from "../../Context/DarkModeContext";
import pageBackground from "../../assets/homepage/page_bg.png";
import courseIcons from "../../assets/homepage/icons.png";
import backgrounds from "../../assets/homepage/backgrounds.png";

const homeStyles = {
  "student-home":
    "motion-safe:animate-homeFadeIn min-h-screen [padding:48px_32px_24px] [color:#071e3d] relative isolate bg-[#eef6ff] overflow-hidden [&_a:focus-visible]:[outline:3px_solid_#f7b733] [&_a:focus-visible]:[outline-offset:4px] max-[1200px]:[padding:32px_22px_22px] max-md:[padding:25px_16px]",
  "home-welcome":
    "mt-20 relative [padding:8px_16px_26px] [&_h1]:[font-size:clamp(32px,4.2vw,66px)] [&_h1]:font-extrabold [&_h1]:[letter-spacing:-.045em] [&_h1]:[line-height:1.12] [&_h1]:[margin:0_0_10px] [&_h1]:[overflow-wrap:anywhere] [&_h1_span]:[color:#e60028] max-lg:pt-20 max-md:px-0.5 max-md:pb-6",
  "home-eyebrow":
    "uppercase [letter-spacing:.42em] [font-size:12px] font-bold [margin:0_0_14px] max-md:[font-size:10px] max-md:[letter-spacing:.3em]",
  "home-subtitle": "[font-size:clamp(16px,1.65vw,25px)] [line-height:1.5] m-0",
  "home-welcome-line":
    "[height:5px] [width:84px] [background:#f00530] [border-radius:10px] [margin-top:15px]",
  "home-cards":
    "mt-4 grid max-w-[1600px] mx-auto grid-cols-[repeat(auto-fit,minmax(min(100%,280px),1fr))] gap-5",
  "home-card":
    "motion-safe:animate-homeCardIn relative flex flex-col min-w-0 [border-radius:20px] [padding:22px_24px_20px] text-white overflow-hidden [box-shadow:0_12px_24px_#17477c16] [border:1px_solid_#ffffff35] [&_h2]:[font-size:clamp(25px,2.5vw,38px)] [&_h2]:font-extrabold [&_h2]:[letter-spacing:-.03em] [&_h2]:[margin:10px_0_12px] [&_h2]:[line-height:1.2] min-[1600px]:[min-height:470px] max-[1200px]:[padding:18px_16px] max-md:[padding:22px_24px] max-md:[&_h2]:[font-size:32px]",
  "home-card-buy":
    "motion-safe:[animation-delay:150ms] isolate bg-[#b80e29] [&_.home-card-action]:[color:#e50025]",
  "home-card-courses":
    "motion-safe:[animation-delay:350ms] isolate bg-[#0068e9]",
  "home-card-app":
    "motion-safe:[animation-delay:550ms] isolate bg-[#09294e] [&_.home-card-copy_p]:[font-size:18px]",
  "home-card-copy":
    "relative flex-1 [&_p]:[font-size:21px] [&_p]:[line-height:1.6] [&_p]:text-center [&_p]:[margin:0_0_26px] [&_p]:[color:#fffef2] max-[1200px]:[&_p]:[font-size:18px] max-md:[&_p]:[font-size:20px]",
  "home-card-action":
    "relative flex items-center justify-center [gap:16px] [background:#fffafa] [border-radius:15px] [min-height:58px] [padding:12px_8px] [color:#004be4] [font-size:18px] font-bold no-underline [transition:transform_.2s,box-shadow_.2s] [&:hover]:[transform:translateY(-2px)] [&:hover]:[box-shadow:0_6px_18px_#00142a30] max-[1200px]:[font-size:15px] max-[1200px]:[gap:10px] max-md:[font-size:18px] motion-reduce:transition-none",
  "home-art":
    "[height:190px] relative flex items-center justify-center shrink-0 [filter:drop-shadow(0_14px_12px_#00142a35)] min-[1600px]:[height:220px] max-[1200px]:[height:170px] max-md:[height:190px]",
  "home-footer":
    "flex flex-wrap max-w-[1600px] mx-auto items-center [gap:24px] [border-top:1px_solid_#dce5ef] [margin-top:22px] [padding:20px_4px_0] [color:#63758d] [font-size:14px] [&>p]:[padding-left:24px] [&>p]:[border-left:1px_solid_#dce5ef] [&>p]:[font-size:12px] [&>p]:[line-height:1.5] max-md:flex-wrap max-md:[gap:16px] max-md:[&>p]:w-full max-md:[&>p]:[border:0] max-md:[&>p]:p-0",
  "home-founder":
    "flex items-center [gap:12px] no-underline [color:inherit] [&>span:first-child]:grid [&>span:first-child]:place-items-center [&>span:first-child]:[width:38px] [&>span:first-child]:[height:38px] [&>span:first-child]:shrink-0 [&>span:first-child]:[background:#dce6f1] [&>span:first-child]:rounded-full [&>span:first-child]:[color:#16345a] [&>span:first-child]:font-bold [&_strong]:font-semibold max-md:[font-size:12px]",
  "home-socials":
    "flex [gap:20px] ml-auto [font-size:22px] [&_a]:[color:inherit] max-md:[margin-left:0]",
  "student-home-dark":
    " [color:#edf4ff] [&_.home-footer]:[border-color:#33445a] [&_.home-footer]:[color:#acbdd2] [&_.home-footer>p]:[border-color:#33445a]",
};
const homeClass = (names) =>
  names
    .split(" ")
    .map((name) => `${name} ${homeStyles[name] || ""}`)
    .join(" ");

// SVG viewports crop the sheet while preserving the original image proportions.
const backgroundCrops = {
  red: "14 496 545 400",
  blue: "575 495 524 400",
  navy: "1115 494 541 404",
};

function PanelBackground({ panel, dimmed = false }) {
  const isPage = panel === "page";
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-[inherit]"
    >
      {isPage ? (
        <img
          src={pageBackground}
          alt=""
          width="1672"
          height="941"
          className="absolute inset-0 h-full w-full object-cover"
          draggable="false"
        />
      ) : (
        <svg
          viewBox={backgroundCrops[panel]}
          preserveAspectRatio="xMidYMid slice"
          className="absolute inset-0 h-full w-full dark:hidden"
          focusable="false"
        >
          <image href={backgrounds} width="1672" height="941" />
        </svg>
      )}
      {dimmed && <div className="absolute inset-0 bg-[#061827]/95" />}
    </div>
  );
}

// Each illustration is clipped before fitting it into the responsive artwork area.
const artworkCrops = {
  books: { x: 20, y: 125, width: 625, height: 515 },
  laptop: { x: 650, y: 105, width: 775, height: 505 },
  app: { x: 1430, y: 135, width: 720, height: 475 },
};

function CourseArtwork({ kind }) {
  const { x, y, width, height } = artworkCrops[kind];
  return (
    <div className={homeClass("home-art")} aria-hidden="true">
      <svg
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid meet"
        className="block h-full w-full max-w-[340px]"
        focusable="false"
      >
        <svg width={width} height={height} overflow="hidden">
          <image href={courseIcons} x={-x} y={-y} width="2159" height="728" />
        </svg>
      </svg>
    </div>
  );
}

export default function HomePage() {
  const { isDarkMode } = useContext(DarkModeContext);
  const { userName } = useOutletContext() || {};
  const firstName = (userName || "Student").trim().split(/\s+/)[0];
  return (
    <div
      className={homeClass(
        `student-home ${isDarkMode ? "student-home-dark" : ""}`,
      )}
    >
      <PanelBackground panel="page" dimmed={isDarkMode} />
      <section
        className={homeClass("home-welcome")}
        aria-labelledby="welcome-heading"
      >
        <p className={homeClass("home-eyebrow")}>Good to see you again</p>
        <h1 id="welcome-heading">
          Welcome back, <span>{firstName}</span>
        </h1>
        <p className={homeClass("home-subtitle")}>
          Keep going. A better you is always a few practice questions away.
        </p>
        <div className={homeClass("home-welcome-line")} />
      </section>
      <section
        className={homeClass("home-cards")}
        aria-label="Your learning starts here"
      >
        <article className={homeClass("home-card home-card-buy")}>
          <PanelBackground panel="red" />
          <CourseArtwork kind="books" />
          <div className={homeClass("home-card-copy")}>
            <h2>Buy a New Course</h2>
            <p lang="ar" dir="rtl">
              اختر المواد، واشترك في الكورس المخصص لجامعتك.
            </p>
          </div>
          <Link className={homeClass("home-card-action")} to="/student-folders">
            Explore Courses <FaArrowRight />
          </Link>
        </article>
        <article className={homeClass("home-card home-card-courses")}>
          <PanelBackground panel="blue" />
          <CourseArtwork kind="laptop" />
          <div className={homeClass("home-card-copy")}>
            <h2>My Courses</h2>
            <p lang="ar" dir="rtl">
              اوصل للكورسات اللي إنت مشترك فيها وكمل مذاكرتك.
            </p>
          </div>
          <Link className={homeClass("home-card-action")} to="/my-courses">
            View My Courses <FaArrowRight />
          </Link>
        </article>
        <article className={homeClass("home-card home-card-app")}>
          <PanelBackground panel="navy" />
          <CourseArtwork kind="app" />
          <div className={homeClass("home-card-copy")}>
            <h2>EduHigh App</h2>
            <p lang="ar" dir="rtl">
              اتدرب على بنك الأسئلة، راجع أخطاءك، تابع مستواك، تواصل مع زمايلك،
              واحصل على امتحانات سابقة وآلاف المسائل، واستمتع بالـ EduStreaks.
            </p>
          </div>
          <a
            className={homeClass("home-card-action")}
            href="https://app.edu-high.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open EduHigh App <FaExternalLinkAlt />
          </a>
        </article>
      </section>
      <footer className={homeClass("home-footer")}>
        <a
          href="https://app.edu-high.com/founder/youssef-sherif"
          target="_blank"
          rel="noopener noreferrer"
          className={homeClass("home-founder")}
        >
          <span>YS</span>
          <span>
            Founded by <strong>Eng. Youssef Sherif</strong>
          </span>
          <FaArrowRight />
        </a>
        <div className={homeClass("home-socials")}>
          <a
            href="https://www.instagram.com/youssef.sherif28"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://youtube.com/@youssefsherif28"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube />
          </a>
          <a
            href="https://www.facebook.com/youssef.sherif.math.instructor"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
        </div>
        <p>
          Building brighter students,
          <br />
          one concept at a time.
        </p>
      </footer>
    </div>
  );
}
